import service from "./axiosConfig";

// 获取题库列表
export const getQuestionbankList = (params) => {
  return service.get("/interface/wrjquestionbank/list", { params });
};

// 获取随机题目
export const getRandomQuestions = (params) => {
  return service.get("/interface/wrjquestionbank/random", { params });
};

// 开始模拟考核
export const startExam = (params) => {
  return service.get("/interface/wrjquestionbank/exam/start", { params });
};

// 提交模拟考核答案
export const submitExam = (data) => {
  return service.post("/interface/wrjquestionbank/exam/submit", data);
};

// 获取用户考核历史（分页）
export const getExamHistory = (pageNum = 1, pageSize = 5) => {
  return service.get("/interface/wrjquestionbank/exam/history", { params: { pageNum, pageSize } });
};

// 获取考核详情
export const getExamDetail = (recordId) => {
  return service.get("/interface/wrjquestionbank/exam/detail", { params: { recordId } });
};

// 获取学习资料列表
export const getKnowledgebaseList = (params) => {
  return service.get("/interface/wrjknowledgebase/list", { params });
};

// 获取学习资料详情
export const getKnowledgebaseDetail = (id) => {
  return service.get("/interface/wrjknowledgebase/detail", { params: { id } });
};

// 获取首页学习资料
export const getHomeKnowledgebase = () => {
  return service.get("/interface/home/knowledgebase");
};

// 获取用户成绩排行榜
export const getLeaderboard = () => {
  return service.get("/interface/home/leaderboard");
};

// 添加用户错题记录
export const addUselearn = (data) => {
  return service.post("/interface/uselearn/add", data);
};

// 获取用户错题列表
export const getUselearnList = (pageNum = 1, pageSize = 5) => {
  return service.get(`/interface/uselearn/list?pageNum=${pageNum}&pageSize=${pageSize}`);
};

// 获取用户错题详情
export const getUselearnDetail = (id) => {
  return service.get(`/interface/uselearn/detail?id=${id}`);
};

// 获取个人中心排名信息
export const getPersonalRanking = () => {
  return service.get("/interface/wrj/personal/ranking");
};


// 删除用户错题记录
export const deleteUselearn = (id) => {
  return service.delete("/interface/uselearn/delete", { params: { id } });
};

// 删除考核记录
export const deleteExamRecord = (recordId) => {
  return service.delete("/interface/wrjquestionbank/exam/delete", { params: { recordId } });
};

// 获取无人机赛事文档列表（分页）
export const getWrjNewsList = (params = {}) => {
  const { pageNum = 1, pageSize = 10, title = "" } = params;
  return service.get("/interface/wrjnews/list", { params: { pageNum, pageSize, title } });
};

// 获取无人机赛事文档详情
export const getWrjNewsDetail = (id) => {
  return service.get("/interface/wrjnews/detail", { params: { id } });
};
